import { types } from 'mobx-state-tree'

export const Test = types.model('TestStore', {
  isTest: types.maybe(types.boolean),
}).actions(self => ({
  set() {
    self.isTest = true
  },
}))
